import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TrendingInstagramInfluencersV2.graphql';
import { Query, QuerytrendingInstagramInfluencersV2Args } from '../../__generated__/globalTypes';

export const useTrendingInstagramInfluencersV2Query = (
  options?: QueryHookOptions<Query, QuerytrendingInstagramInfluencersV2Args>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytrendingInstagramInfluencersV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTrendingInstagramInfluencersV2LazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytrendingInstagramInfluencersV2Args>
): QueryResult<Query, QuerytrendingInstagramInfluencersV2Args> & {
  getTrendingInstagramInfluencersV2: LazyQueryExecFunction<Query, QuerytrendingInstagramInfluencersV2Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTrendingInstagramInfluencersV2, result] = useLazyQuery<Query, QuerytrendingInstagramInfluencersV2Args>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getTrendingInstagramInfluencersV2, ...result };
};

export const useTrendingInstagramInfluencersV2PromiseQuery = () => {
  const client = useApolloClient();

  const getTrendingInstagramInfluencersV2 = useCallback(
    (options?: Omit<QueryOptions<QuerytrendingInstagramInfluencersV2Args, Query>, 'query'>) =>
      client.query<Query, QuerytrendingInstagramInfluencersV2Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getTrendingInstagramInfluencersV2 };
};
// Suspense Query Hooks
export const useTrendingInstagramInfluencersV2SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytrendingInstagramInfluencersV2Args>
) => {
  const result = useSuspenseQuery<Query, QuerytrendingInstagramInfluencersV2Args>(QUERY, {
    ...options
  });

  return result;
};
